<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/rental/gin/index">Manage Rental GIN</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create Rental Invoice
      </h6>

      <div class="container-fluid">
        <div class="card custom_bdr_rds">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else>
              <form @submit.prevent="createInvoice">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">Customer</label>
                      <input class="form-control" :value="ginHeader.customer_name" disabled />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">GIN No.</label>
                      <input class="form-control" :value="ginHeader.SI_issueNum" disabled />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">Invoice Type</label>
                      <input class="form-control" value="Rental Invoice" disabled />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">Sales Person</label>
                      <input class="form-control" :value="ginHeader.sales_person" disabled />
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">Delivery Address</label>
                      <textarea class="form-control" rows="2" :value="ginHeader.delivery_address" disabled></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="custom-label" style="font-size: small;">Remarks</label>
                      <textarea class="form-control" rows="2" v-model="invoice.remarks"></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group required">
                      <label class="custom-label" style="font-size: small;">Invoice Date</label>
                      <input type="date" class="form-control" v-model="invoice.invoice_date" required />
                    </div>
                  </div>
                </div>

                <div class="card custom_bdr_rds mt-3">
                  <div class="card-body custom_bdr_rds">
                    <h6 class="purchitem mb-2"><b>Available Items for Invoice</b></h6>
                    <div class="table-responsive mb-1">
                      <table class="table table-sm table-hover" style="font-size: small;">
                        <thead class="background_color2 rental-invoice-table-head">
                          <tr>
                            <th></th>
                            <th>Product Code</th>
                            <th>Product Description</th>
                            <th>Serial No.</th>
                            <th>Rental Period</th>
                            <th>Rate Per Month</th>
                            <th>Rate Per Day</th>
                            <th>Qty</th>
                            <th>Invoice From</th>
                            <th>Invoice To</th>
                            <th>Month Used</th>
                            <th>Bill Amount</th>
                            <th>Discount %</th>
                            <th>Discounted Line Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in rentalRows" :key="item.rowKey">
                            <td>
                              <input type="checkbox" v-model="item.selected" />
                            </td>
                            <td>{{ item.P_code }}</td>
                            <td>{{ item.P_description || item.machine || item.model || '-' }}</td>
                            <td>{{ item.serial_no || '-' }}</td>
                            <td>
                              {{ formatDateDisplay(item.from_date) || '-' }} to {{ formatDateDisplay(item.to_date) || '-' }}
                            </td>
                            <td class="text_right">{{ formatMoney(item.rate_per_month) }}</td>
                            <td class="text_right">{{ formatMoney(item.rate_per_day) }}</td>
                            <td class="text_right">{{ formatQty(item.qty) }}</td>
                            <td>
                              <input type="date" class="form-control" v-model="item.invoice_from" @input="recalculate(index)" />
                            </td>
                            <td>
                              <input type="date" class="form-control" v-model="item.invoice_to" @input="recalculate(index)" />
                            </td>
                            <td>
                              <input type="number" min="0" class="form-control" v-model.number="item.days_used"  />
                            </td>
                            <td>
                              <input type="number" min="0" step="0.01" class="form-control text_right" v-model.number="item.bill_amt" @input="recalculate(index)" />
                            </td>
                            <td>
                              <input type="number" min="0" step="0.01" class="form-control text_right" v-model.number="item.discount" @input="recalculate(index)" />
                            </td>
                            <td>
                              <input type="text" class="form-control text_right" :value="formatMoney(item.line_amt)" disabled />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row mt-3 justify-content-end">
                  <div class="col-md-4 col-lg-3">
                    <table class="table table-sm table-borderless rental-total-table">
                      <tbody>
                        <tr>
                          <td><b>Sub Total</b></td>
                          <td class="text-end">{{ formatMoney(totals.subtotal) }}</td>
                        </tr>
                        <tr>
                          <td><b>Fixed Charges</b></td>
                          <td class="text-end">{{ formatMoney(totals.fixedCharges) }}</td>
                        </tr>
                        <tr>
                          <td><b>NBT</b></td>
                          <td class="text-end">{{ formatMoney(totals.nbt) }}</td>
                        </tr>
                        <tr>
                          <td><b>VAT</b></td>
                          <td class="text-end">{{ formatMoney(totals.vat) }}</td>
                        </tr>
                        <tr>
                          <td><b>Total</b></td>
                          <td class="text-end"><b>{{ formatMoney(totals.total) }}</b></td>
                        </tr>
                        <tr>
                          <td><b>Less Adv.</b></td>
                          <td class="text-end">
                            <input type="number" min="0" step="0.01" class="form-control text_right rental-advance-input" v-model.number="invoice.advance_payment" @input="recalculateTotals" />
                          </td>
                        </tr>
                        <tr>
                          <td><b>Total Payable</b></td>
                          <td class="text-end"><b>{{ formatMoney(totals.totalPayable) }}</b></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="navbar p-0 mt-3" style="border-bottom: 0;">
                  <div></div>
                  <div>
                    <button
                      v-if="!savedInvoiceId"
                      type="submit"
                      class="btn btn-outline-primary mb-1 bdr-rad"
                      :disabled="isSaving || !hasSelectedRows"
                    >
                      {{ isSaving ? 'Creating...' : 'Create Rental Invoice' }}
                    </button>
                    <button
                      v-if="savedInvoiceId && invoiceStatus !== 3"
                      type="button"
                      class="btn btn-outline-success mb-1 bdr-rad ms-2"
                      @click="confirmInvoice"
                    >
                      Confirm
                    </button>
                    <button v-if="savedInvoiceId && invoiceStatus === 3" type="button" class="btn btn-success mb-1 bdr-rad ms-2" disabled>
                      Confirmed
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  name: 'CreaterentalInvoice',
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      id: this.$route.query.id,
      isLoading: true,
      isSaving: false,
      ginHeader: {
        SI_issueNum: '',
        customer_name: '',
        sales_person: '',
        delivery_address: '',
      },
      sourceCustomerId: 0,
      sourceSalesPersonId: 0,
      sourceCustomerContact: '',
      savedInvoiceId: 0,
      invoice: {
        invoice_date: new Date().toISOString().slice(0, 10),
        remarks: '',
        advance_payment: 0,
      },
      invoiceStatus: 0,
      rentalRows: [],
      totals: {
        subtotal: 0,
        fixedCharges: 0,
        nbt: 0,
        vat: 0,
        total: 0,
        totalPayable: 0,
      },
    };
  },
  computed: {
    hasSelectedRows() {
      return this.rentalRows.some((row) => row.selected);
    },
  },
  mounted() {
    this.loadRentalInvoiceData();
  },
  methods: {
    formatMoney(value) {
      const num = Number(value || 0);
      return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatQty(value) {
      const num = Number(value || 0);
      return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatDateDisplay(value) {
      if (!value || value === '0000-00-00') return '';
      const parts = String(value).slice(0, 10).split('-');
      if (parts.length !== 3) return value;
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    parseAmount(value) {
      return Number(String(value || 0).replace(/,/g, '')) || 0;
    },
    daysBetween(fromDate, toDate) {
      if (!fromDate || !toDate) return 0;
      const [fy, fm, fd] = String(fromDate).slice(0, 10).split('-').map(Number);
      const [ty, tm, td] = String(toDate).slice(0, 10).split('-').map(Number);
      const from = Date.UTC(fy, (fm || 1) - 1, fd || 1);
      const to = Date.UTC(ty, (tm || 1) - 1, td || 1);
      const diff = Math.ceil((to - from) / (1000 * 60 * 60 * 24)) + 1;
      return Number.isFinite(diff) && diff > 0 ? diff : 0;
    },
    normalizeDate(value) {
      if (!value) return '';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      return d.toISOString().slice(0, 10);
    },
    async loadRentalInvoiceData() {
      this.isLoading = true;
      try {
        const headers = {
          Authorization: 'Bearer ' + this.access_token,
          'Content-type': 'application/json',
        };

        const loadedNewInvoice = await this.loadNewRentalInvoiceData(headers);
        if (loadedNewInvoice) {
          this.recalculateTotals();
          return;
        }

        const loadedFromGin = await this.loadNewRentalGinData(headers);
        if (loadedFromGin) {
          this.recalculateTotals();
          return;
        }

        this.ginHeader = {
          SI_issueNum: '',
          customer_name: '',
          sales_person: '',
          delivery_address: '',
        };
        this.rentalRows = [];
        this.recalculateTotals();
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadNewRentalGinData(headers) {
      try {
        const { data } = await axios.get('/rentalgin/view?id=' + this.id, { headers });
        if (!data || data.status !== 1 || !data.all_data) {
          return false;
        }

        const gin = data.all_data;
        const details = data.detail || [];
        this.sourceCustomerId = Number(gin.customer_id || 0);
        this.sourceSalesPersonId = Number(gin.sales_person_id || 0);
        this.sourceCustomerContact = gin.customer_contact || '';
        this.ginHeader = {
          SI_issueNum: gin.issue_no || '',
          customer_name: gin.customer_name || '',
          sales_person: gin.sales_person_name || '',
          delivery_address: gin.customer_contact ? 'Contact No: ' + gin.customer_contact : '',
        };

        this.invoice.remarks = this.invoice.remarks || gin.remarks || '';
        this.rentalRows = details.map((row) => {
          const rowId = row.id;
          const ratePerDay = this.parseAmount(row.per_day_rate);
          const qty = Number(row.gin_qty || 1);
          return {
            rowKey: rowId,
            selected: true,
            vehicle_id: row.vehicle_id || 0,
            id_gin_dtl: rowId,
            P_code: row.engine_no || '',
            P_description: row.model_name || '',
            serial_no: row.chassis_no || '',
            model_name: row.model_name || '',
            engine_no: row.engine_no || '',
            chassis_no: row.chassis_no || '',
            color: row.color || '',
            from_date: row.from_date || '',
            to_date: row.to_date || '',
            rate_per_month: 0,
            rate_per_day: ratePerDay,
            qty,
            invoice_from: row.from_date || '',
            invoice_to: row.to_date || '',
            days_used: this.daysBetween(row.from_date, row.to_date) || 1,
            bill_amt: ratePerDay,
            discount: 0,
            line_amt: ratePerDay * qty * (this.daysBetween(row.from_date, row.to_date) || 1),
          };
        });

        return true;
      } catch (error) {
        if (error.response && error.response.status !== 404) {
          console.log(error.response || error);
        }
        return false;
      }
    },
    async loadNewRentalInvoiceData(headers) {
      try {
        const { data } = await axios.get('/rentalinvoice/view?id=' + this.id, { headers });
        if (!data || data.status !== 1 || !data.all_data) {
          return false;
        }

        const gin = data.all_data;
        const details = data.detail || [];
        this.savedInvoiceId = Number(gin.id || this.id || 0);
        this.invoiceStatus = Number(gin.status || 0);
        this.sourceCustomerId = Number(gin.customer_id || 0);
        this.sourceSalesPersonId = Number(gin.sales_person_id || 0);
        this.sourceCustomerContact = gin.customer_contact || '';
        this.ginHeader = {
          SI_issueNum: gin.issue_no || '',
          customer_name: gin.customer_name || '',
          sales_person: gin.sales_person_name || '',
          delivery_address: gin.customer_contact ? 'Contact No: ' + gin.customer_contact : '',
        };

        this.invoice.remarks = this.invoice.remarks || gin.remarks || '';
        this.rentalRows = details.map((row) => {
          const rowId = row.id;
          const ratePerDay = this.parseAmount(row.per_day_rate);
          const qty = Number(row.gin_qty || 1);
          return {
            rowKey: rowId,
            selected: true,
            vehicle_id: row.vehicle_id || 0,
            id_gin_dtl: rowId,
            P_code: row.engine_no || '',
            P_description: row.model_name || '',
            serial_no: row.chassis_no || '',
            model_name: row.model_name || '',
            engine_no: row.engine_no || '',
            chassis_no: row.chassis_no || '',
            color: row.color || '',
            from_date: row.from_date || '',
            to_date: row.to_date || '',
            rate_per_month: 0,
            rate_per_day: ratePerDay,
            qty,
            invoice_from: row.from_date || '',
            invoice_to: row.to_date || '',
            days_used: this.daysBetween(row.from_date, row.to_date) || 1,
            bill_amt: ratePerDay,
            discount: 0,
            line_amt: ratePerDay * qty * (this.daysBetween(row.from_date, row.to_date) || 1),
          };
        });

        return true;
      } catch (error) {
        if (error.response && error.response.status !== 404) {
          console.log(error.response || error);
        }
        return false;
      }
    },
    recalculate(index) {
      const row = this.rentalRows[index];
      if (!row) return;
      const qty = Number(row.qty || 0);
      const discount = Number(row.discount || 0);
      const days = this.daysBetween(row.invoice_from, row.invoice_to) || 1;
      row.days_used = days;
      const ratePerDay = Number(row.rate_per_day || 0);
      const bill = ratePerDay > 0 ? ratePerDay * days : Number(row.bill_amt || 0);
      if (ratePerDay > 0) {
        row.bill_amt = bill;
      }
      row.line_amt = (bill * qty * (100 - discount)) / 100;
      this.recalculateTotals();
    },
    recalculateTotals() {
      this.totals.subtotal = this.rentalRows
        .filter((row) => row.selected)
        .reduce((sum, row) => sum + Number(row.line_amt || 0), 0);
      this.totals.nbt = (this.totals.subtotal * 2) / 98;
      this.totals.vat = (this.totals.subtotal + this.totals.nbt) * 0.15;
      this.totals.total = this.totals.subtotal + Number(this.totals.fixedCharges || 0) + this.totals.nbt + this.totals.vat;
      this.totals.totalPayable = this.totals.total - Number(this.invoice.advance_payment || 0);
    },
    async createInvoice() {
      this.isSaving = true;
      try {
        const payload = {
          userid: this.userid,
          header: {
            issue_date: this.invoice.invoice_date,
            invoice_date: this.invoice.invoice_date,
            customer_id: this.sourceCustomerId || 0,
            customer_name: this.ginHeader.customer_name || '',
            customer_contact: this.sourceCustomerContact || '',
            sales_person_id: this.sourceSalesPersonId || 0,
            sales_person_name: this.ginHeader.sales_person || '',
            remarks: this.invoice.remarks || '',
          },
          details: this.rentalRows.map((row) => ({
            selected: row.selected,
            vehicle_id: row.vehicle_id || 0,
            model_name: row.model_name || row.P_description || '',
            engine_no: row.engine_no || row.P_code || '',
            chassis_no: row.chassis_no || row.serial_no || '',
            color: row.color || '',
            invoice_from: row.invoice_from,
            invoice_to: row.invoice_to,
            days_used: row.days_used || 1,
            per_day_rate: row.rate_per_day || 0,
            bill_amt: row.bill_amt || 0,
            discount: row.discount || 0,
            line_amt: row.line_amt || 0,
          })),
        };

        const { data } = await axios.post('/rentalinvoice/create', payload, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });

        if (data && data.status === 1 && data.id) {
          this.savedInvoiceId = data.id;
          this.id = data.id;
          this.invoiceStatus = 1;
          await this.loadRentalInvoiceData();
          this.$router.push('/rental/invoice/index');
        }
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isSaving = false;
      }
    },
    async confirmInvoice() {
      if (!this.id) return;
      try {
        const { data } = await axios.post('/rentalinvoice/confirm?id=' + this.id, {}, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        if (data && data.status === 1) {
          this.$router.push('/rental/calnder');
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
  watch: {
    rentalRows: {
      deep: true,
      handler() {
        this.recalculateTotals();
      },
    },
  },
};
</script>

<style scoped>
.rental-invoice-table-head th {
  color: #fff;
}

.rental-total-table {
  font-size: small;
  margin-left: auto;
  margin-bottom: 0;
}

.rental-total-table td {
  padding: 5px 0.35rem;
  vertical-align: middle;
}

.rental-advance-input {
  max-width: 180px;
  margin-left: auto;
}
</style>
